/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Signupquestionsmax2Inputs */

const en_signupquestionsmax2 = /** @type {(inputs: Signupquestionsmax2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`At most ${i?.max} questions`)
};

const de_signupquestionsmax2 = /** @type {(inputs: Signupquestionsmax2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Höchstens ${i?.max} Fragen`)
};

/**
* | output |
* | --- |
* | "At most {max} questions" |
*
* @param {Signupquestionsmax2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupquestionsmax2 = /** @type {((inputs: Signupquestionsmax2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupquestionsmax2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupquestionsmax2(inputs)
	return de_signupquestionsmax2(inputs)
});
export { signupquestionsmax2 as "signupQuestionsMax" }